import { render, staticRenderFns } from "./AddAssessmentPreviousBatch.vue?vue&type=template&id=d48080ee"
import script from "./AddAssessmentPreviousBatch.vue?vue&type=script&lang=js"
export * from "./AddAssessmentPreviousBatch.vue?vue&type=script&lang=js"
import style0 from "./AddAssessmentPreviousBatch.vue?vue&type=style&index=0&id=d48080ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports